
<template>
    <div class="main-content">
        <section class="section sec-style mt-5">
            <div class="section-body">

                <template v-if="loading === false">
                    <div class="row">
                       <div class="col-md-12">
                            <b-card class="card-t-bio bdr-15">
                                <div class="biolink-wrapper d-flex align-items-center" @click="show_link = !show_link">
                                    <div class="t-bio-nm">
                                        <strong>Website: </strong> {{website.domain}}
                                    </div>
                                    <div class="t-bio-link pt-1 ml-auto">
                                        <a target="_blank" :href="'https://' + website.domain" class="border-0">Visit Site <i class="uil uil-angle-right"></i></a>
                                    </div>
                                </div>
                            </b-card>
                        </div>
                    </div>
                    <div class="row row-step-w">
                        <div class="col-md-12">
                            <div class="wizard-steps wizard-appearance">
                                <div v-for="(data,index) in menu_event" 
                                    :key="index" :class="{'wizard-step-active': data.name === menu_active}" 
                                    class="wizard-step"
                                    v-on:click="menu_active = data.name"
                                >
                                    <div class="wizard-step-icon">
                                        <i :class="data.icon"></i>
                                    </div>
                                    <div class="wizard-step-label">
                                        {{data.name}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-7 col-event">
                            <component :is="menuWebsite" :menu_active="menu_active" @alertPackage="alertPackage"></component>
                        </div>
                    </div>
                </template>

                <div v-if="loading === true" class="row mt-5">
                    <div class="col-12 text-center mt-3">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                </div>
            
            </div>
        </section>
    </div>
</template>

<script>
    import { mapActions,mapState } from 'vuex'

    export default {
        data(){
            return{
                loading:false,
                menu_event: [
                    {id:'1',name:'Basic',icon:'uil uil-browser'},
                    {id:'2',name:'Featured',icon:'uil uil-file-info-alt'},
                    {id:'3',name:'Thema',icon:'uil uil-palette'},
                    {id:'4',name:'Pricelist',icon:'uil uil-pricetag-alt'},
                    {id:'5',name:'Testimonial',icon:'uil uil-comment-dots'},
                    {id:'6',name:'Faq',icon:'uil uil-question-circle'},
                    {id:'7',name:'Setting',icon:'uil uil-setting'},
                ],
                menu_active:'Basic',
            }
        },
        mounted(){
            this._getWebsite(this.$route.params.id)
        },
        computed:{
            ...mapState('WebsiteControl', {
                website: state => state.website,
            }),

            menuWebsite () {
                let menu = this.menu_active
                return () => import(`../website/component/${menu}`)
            },
        },
        methods:{
            ...mapActions('WebsiteControl', ['getWebsite']),
            
            _getWebsite: function(id){
                this.loading = true
                this.getWebsite(id).then(() => {
                    this.loading = false
                }).catch((error) => {
                    console.log(error)
                    this.loading = false
                    this.$router.push({ name: 'notfound' })
                })
            },
            alertPackage: function(){
                this.$toast.warning('Sorry, Upgrade your package to premium event to use this feature')
            }
        },
        destroyed(){
            // this.CLEAR_DETAIL_EVENT()
        }
    }

</script>